import { analyzeAndValidateNgModules } from '@angular/compiler';
import { Component, Input, OnInit } from '@angular/core';
import { CombineLatestSubscriber } from 'rxjs/internal/observable/combineLatest';
import { SharedService } from 'src/app/shared.service';
import { AttendanceSummaryComponent } from '../attendance-summary.component';
@Component({
  selector: 'app-calculate-leaves',
  templateUrl: './calculate-leaves.component.html',
  styleUrls: ['./calculate-leaves.component.scss']
})
export class CalculateLeavesComponent implements OnInit {
  @Input() employeeList: any;
  @Input() monthList: any;
  @Input() attendanceList: any;
  @Input() clockifyList: any;
  @Input() monthNum: any;
  @Input() year: any;
  constructor(private service: SharedService) {
  }
  ngOnInit(): void {
    // this.RefreshMonthList(this.monthNum, this.year);
    // this.RefreshEmpList();
    // this.RefreshAttendanceList();
  }
  RefreshMonthList(month: number, year: number) {
    this.service.GetCurrentMonth(month, year).subscribe(data => {
      this.monthList = data;
    })
  }
  RefreshEmpList() {
    this.service.GetEmpList().subscribe(data => {
      this.employeeList = data;
    });
  }
  RefreshAttendanceList() {
    this.service.GetAttendanceList()
      .toPromise()
      .then(data => {
        this.attendanceList = data;
      });
  }
  IsWeekend(date: any) {
    for (let i = 0; i < this.monthList.length; i++) {
      if (this.monthList[i]['pkDate'] == date) {
        if (this.monthList[i]['IsWeekday'] == false) {
          return true
        }
      }
    }
    return false
  }
  IsPublicHoliday(date: any) {
    let temp = this.monthList.find((i: { pkDate: any; }) => i.pkDate === date);
    if (temp.IsHoliday) {
      return true
    }
    else {
      return false
    }
  }
  IsBusinessDay(date: any) {
    for (let i = 0; i < this.monthList.length; i++) {
      if (this.monthList[i]['pkDate'] == date) {
        if (this.monthList[i]['IsBusinessDay'] == true) {
          return true
        }
      }
    }
    return false
  }
  CheckAttendance(date: any, emp: any) {
    for (let i = 0; i < this.attendanceList.length; i++) {
      if (this.attendanceList[i]['Date'] == date) {
        if (this.attendanceList[i]['fkEmpId'] == emp) {
          return true
        }
      }
    }
    return false
  }
  CheckClockifyAttendance(date: any, clockifyId: any) {
    //const filter = this.clockifyList.filter((c: any) => c.Date == date && c.ClockifyId == clockifyId && c.clockify.WorkHours != null);
    for (var clockify of this.clockifyList) {
      if (clockify.Date == date && clockify.ClockifyId == clockifyId && clockify.WorkHours != null) {
        return true
      }
    }
    return false
  }
  GetAttendanceHours(date: any, emp: any) {
    for (let i = 0; i < this.attendanceList.length; i++) {
      if (this.attendanceList[i]['Date'] == date) {
        if (this.attendanceList[i]['fkEmpId'] == emp) {
          return this.attendanceList[i].DurationOfTasks
        }
      }
    }
  }
  GetClockifyHours(date: any, clockifyId: any) {
    for (var clockify of this.clockifyList) {
      if (clockify.Date == date && clockify.ClockifyId == clockifyId) {
        return clockify.DurationInMinutes;
      }
    }
  }
  CalculateNonTechnicalLeaves(employee: any) {
    var currentDate = new Date().toISOString().split('T')[0] + 'T00:00:00';
    // var date = new Date(`${this.year}-${month}-${day} 00:00 PST`).toISOString().split('T')[0] + 'T00:00:00';
    for (var day of this.monthList) {
      if (day.pkDate < currentDate) {
        if (this.IsWeekend(day.pkDate)) {
          //console.log('weekend')
          if (this.CheckAttendance(day.pkDate, employee.pkEmpId)) {
            //console.log('present on weekend')
            var compensation =
            {
              fkEmpId: employee.pkEmpId,
              Date: day.pkDate,
              HoursWorked: this.GetAttendanceHours(day.pkDate, employee.pkEmpId)
            }
            this.service.AddCompensation(compensation).subscribe(data => {
              //alert(data.toString())
            });
          }
        }
        else if (this.IsPublicHoliday(day.pkDate)) {
          if (this.CheckAttendance(day.pkDate, employee.pkEmpId)) {
            //console.log('present on holiday')
            var compensation =
            {
              fkEmpId: employee.pkEmpId,
              Date: day.pkDate,
              HoursWorked: this.GetAttendanceHours(day.pkDate, employee.pkEmpId)
            }
            this.service.AddCompensation(compensation).subscribe(data => {
              //alert(data.toString())
            });
          }
        }
        else if (this.IsBusinessDay(day.pkDate)) {
          if (!this.CheckAttendance(day.pkDate, employee.pkEmpId)) {
            var leave =
            {
              fkEmpId: employee.pkEmpId,
              Date: day.pkDate,
              Type: ""
            }
            this.service.AddEmployeeLeave(leave).subscribe(data => {
              // alert(data.toString())
            });
          }
        }
      }
    }
  }
  CalculateTechnicalLeaves(employee: any) {
    var currentDate = new Date().toISOString().split('T')[0] + 'T00:00:00';
    // var date = new Date(`${this.year}-${month}-${day} 00:00 PST`).toISOString().split('T')[0] + 'T00:00:00';
    for (var day of this.monthList) {
      if (day.pkDate < currentDate) {
        if (this.IsWeekend(day.pkDate)) {
          //console.log('weekend')
          if (this.CheckClockifyAttendance(day.pkDate, employee.ClockifyId)) {
            var compensation =
            {
              fkEmpId: employee.pkEmpId,
              Date: day.pkDate,
              HoursWorked: this.GetClockifyHours(day.pkDate, employee.ClockifyId)
            }
            this.service.AddCompensation(compensation).subscribe(data => {
              //alert(data.toString())
            });
          }
        }
        else if (this.IsPublicHoliday(day.pkDate)) {
          //console.log(day.pkDate);
          if (this.CheckClockifyAttendance(day.pkDate, employee.ClockifyId)) {
            var compensation =
            {
              fkEmpId: employee.pkEmpId,
              Date: day.pkDate,
              HoursWorked: this.GetClockifyHours(day.pkDate, employee.ClockifyId)
            }
            this.service.AddCompensation(compensation).subscribe(data => {
              //alert(data.toString())
            });
          }
        }
        else if (this.IsBusinessDay(day.pkDate)) {
          if (this.CheckClockifyAttendance(day.pkDate, employee.ClockifyId) == false) {
            var leave =
            {
              fkEmpId: employee.pkEmpId,
              Date: day.pkDate,
              Type: ""
            }
            this.service.AddEmployeeLeave(leave).subscribe(data => {
              // alert(data.toString())
            });
          }
        }
      }
    }
  }
  CalculateLeaves(employeeList: any) {
    this.service.GetClockifyData(this.monthNum, this.year).subscribe(data => {
      this.clockifyList = data
      for (var employee of employeeList) {
        if (employee.ClockifyId != '') {
          this.CalculateTechnicalLeaves(employee);
        }
        else {
          this.CalculateNonTechnicalLeaves(employee);
        }
      }
    });
  }
}